import type { HttpError } from '@refinedev/core'

/**
 * How often the cabinet page re-reads the cabinet while it is open: its
 * credits and `idle` change as the cabinet is played, and the credit buttons
 * follow them.
 */
export const CABINET_REFRESH_MS = 5_000

/**
 * The page's `refetchInterval`. A re-read that fails (the API restarting, a
 * network blip) keeps the shown cabinet, and the next re-read tries again; it
 * stops only when there is no cabinet to keep up to date: it never loaded, or
 * the API says it is gone (404).
 */
export function cabinetRefreshInterval({
  data,
  error,
}: {
  data: unknown
  error: Partial<Pick<HttpError, 'statusCode' | 'message'>> | null
}): number | false {
  if (error !== null && (data === undefined || error.statusCode === 404)) {
    return false
  }
  return CABINET_REFRESH_MS
}
